module.exports = __webpack_public_path__ + "img/744.964b15d2.jpg";